import axios from "axios"
import { payments } from "../../../../../../config/api"
import { Dispatch } from "redux"
import { ActionType } from "./ActionTypes"

function fetchPayments() {
    return axios.get(payments)
}

export const actionFetchPayments = () => {

    return (dispatch: Dispatch) => {
        dispatch({ type: ActionType.PAYMENTS_LOADING })
        fetchPayments().then((res) => {
            dispatch({ type: ActionType.PAYMENTS_DATA, list: res.data.data })
        }).catch(err => {
            if (err.code === 'ERR_NETWORK') {
                dispatch({ type: ActionType.PAYMENTS_ERROR, message: 'ERR_NETWORK' })
            } else {
                dispatch({ type: ActionType.PAYMENTS_ERROR, message: err.response.data.error })
            }
        })
    }
}
